<template>
  <div ref="create_lr" class="live-answer" :key="la.loading">
    <w-loader v-if="la.loading || la.appointments_loading" :overlay="la.appointments_loading"/>
    <template v-else>
      <BackButton v-if="!is_part_of_a_modal" absolute/>
      <!-- <div class="w-h4 info--text text--darken-1">
        {{ $lang.t('lr.lets-preview-your-new-script', 'Let\'s preview your new script') }}
      </div>
      <div class="w-body-2 mb-7">
        {{$lang.t('lr.configure-your-script-details-and-how-youre-welcoming-and-routing-customers', 'Configure your script details and how you’re welcoming and routing customers.')}}
      </div> -->
      <w-alert
        v-if="la.alert"
        :message="la.alert.message"
        :level="la.alert.level"
        :closable="la.enable_close_alert"
        @closed="la.alert = null"
        class="mb-6"
      />
      <LiveAnswer
        :_la="la"
        @submitted="createLa"
        :title="$lang.t('lr.create-new-script', 'Create new script')"
        :preselected_vendor_id="preselected_vendor_id"
        :preselected_code="code"
        @click:cancel="onClickCancel ? onClickCancel() : $emit('click:cancel')"
        page="create-page"
        @redirectToIndex="redirectToIndex"
      />
    </template>
  </div>
</template>

<script>
  import {vueRedirect, vueComponent} from 'helpers';
  import {get_account_information, is_nxt} from 'phoenix-session-helpers';
  import LA from '../../../console/src/models/LiveAnswer';
  import LiveAnswerVendor from '../../../console/src/models/LiveAnswerVendor';
  import LiveAnswer from '../elements/LiveAnswer.vue';
  import BackButton from '../../../console/src/components/elements/BackButton.vue';
  
  export default {
    props: {
      vendor_id: {
        type: Number,
        required: false,
      },
      code: {
        type: Number,
        required: false,
      },
      postSaveCb: {
        type: Function,
      },
      onClickCancel: {
        type: Function,
      },
    },
    components: {
      LiveAnswer,
      BackButton,
    },
    data() {
      return {
        la: new LA(this.$session, vueComponent(this)),
        preselected_vendor_id: null,
        is_part_of_a_modal: false,
      };
    },
    // eslint-disable-next-line consistent-return
    async created() {
      this.$data.la.loading = true;
      if (this.$route && this.$route.params && this.$route.params.vendor_id) {
        this.$data.preselected_vendor_id = this.$route.params.vendor_id;
      } else if (this.$props.vendor_id) {
        this.$data.preselected_vendor_id = this.$props.vendor_id;
      }

      if (this.$data.preselected_vendor_id) {
        this.$data.preselected_vendor_id = Number.parseInt(this.$data.preselected_vendor_id);
        const vendors = new LiveAnswerVendor();
        await vendors.init();
        if (!vendors.isEligible(this.$data.preselected_vendor_id)) {
          return vueRedirect(this, {name: 'not-found'});
        }
      }
      this.$data.la.prepoluate_business_profile();
      try {
        this.$session.user.account = await get_account_information(this.$session);
        await Promise.all([
          this.$data.la.add_default_contact(this.$session.user.account?.default_voip_phone_id, this.$session.user.account?.default_voip_phone),
          this.$data.la.prepare_generic_names(),
        ]);
      } catch (e) {
        console.log('error while prepopulating a contact.', e);
        this.$data.la.item.contacts = [JSON.parse(JSON.stringify(this.$data.la.empty_contact))];
      }
      this.$data.la.loading = false;
    },
    mounted() {
      this.$data.is_part_of_a_modal = !this.$route || (this.$refs.create_lr && this.$refs.create_lr.closest('.v-dialog'));
      this.$watch(
        () => {
          const a = this.$data.la && this.$data.la.alert;
          return a ? `${a.level}\u0000${a.message}` : '';
        },
        (key) => {
          if (key) {
            this.scrollPageTopForAlert();
          }
        }
      );
    },
    methods: {
      /**
       * Same as show.vue: scroll layout containers to top so w-alert is visible (console
       * often scrolls #main-content, not window).
       */
      scrollPageTopForAlert() {
        this.$nextTick(() => {
          setTimeout(() => {
            const setTop0 = (el) => {
              if (el && typeof el.scrollTop === 'number') {
                el.scrollTop = 0;
              }
            };
            ['#main-content', '#page-content', '#page-container'].forEach((sel) => {
              setTop0(document.querySelector(sel));
            });
            let node = this.$el;
            while (node && node !== document.body) {
              const { overflowY, overflow } = window.getComputedStyle(node);
              const scrollableY = /(auto|scroll|overlay)/.test(overflowY)
                || /(auto|scroll|overlay)/.test(overflow);
              if (scrollableY && node.scrollHeight > node.clientHeight) {
                setTop0(node);
              }
              node = node.parentElement;
            }
            if (document.scrollingElement) {
              setTop0(document.scrollingElement);
            }
            setTop0(document.documentElement);
            setTop0(document.body);
            try {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            } catch (e) {
              window.scrollTo(0, 0);
            }
          }, 100);
        });
      },
      async createLa(data) {
        const newScript = await this.$data.la.create(data);
        if (this.$data.la.alert && this.$data.la.alert.level === 'success' && this.$props.postSaveCb) {
          this.$props.postSaveCb(newScript);
        }
      },
      redirectToIndex() {
        this.$props.postSaveCb();
      }
    }
  };
</script>

<style scoped>
  .wrapper-body{
    min-height: 400px;
  }
</style>